import React from 'react';

const Card = ({ className, children }) =>
  <div className={['plan-card', className].join(' ').trim()}>{children}</div>;

export default Card
